import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Autocomplete
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";


function ProjectTemplateForm() {

  const navigate = useNavigate();
  const { id } = useParams(); // if id is present => edit mode
  const mode = id ? "edit" : "add";

  const { userData } = useAuthStore();

  console.log("full uer data is : ", userData);

  const org = userData?.organization;

  const fetchProjectTemplates = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/project-templates/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;

      if (data) {
        setFormData({
          organization_id: data.organization_id || "",
          organization_entity_id: data.organization_entity_id || "",
          template_name: data.template_name || "",
          template_description: data.template_description || "",
          organization_project_category_id: data.organization_project_category_id || "",
          organization_project_subcategory_id: data.organization_project_subcategory_id || "",
          created_by: data.created_by || ""
        });
      }
    } catch (error) {
      toast.error("Failed to fetch project template data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mode === "edit" && id) {
      fetchProjectTemplates();
    }
  }, [mode, id]);

  const [formData, setFormData] = useState({
    organization_id: org?.organization_id || "",
    organization_entity_id: "",
    template_name: "",
    template_description: "",
    organization_project_category_id: "",
    organization_project_subcategory_id: "",
    created_by: ""
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {

    const errors = {};

    if (!formData.organization_project_category_id) errors.organization_project_category_id = "Project Category is required";
    if (!formData.template_name) errors.template_name = "Project Template Name is required";
    if (formData.template_name.length > 100) errors.template_name = "Max 100 characters allowed";
    if (formData.template_description && formData.template_description.length > 255)
      errors.template_description = "Max 255 characters allowed";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    let organization_entity_id = userData?.organization?.
      entities?.organization_entity_id || null;

    setBtnLoading(true);
    try {
      const token = localStorage.getItem("token");


      if (mode === "edit") {
        await axios.put(`${MAIN_URL}/api/project-management/project-templates/${id}`, { ...formData, organization_entity_id, organization_id: org?.organization_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project Templates updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/project-templates`, { ...formData, organization_entity_id, organization_id: org?.organization_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project Templates added");
      }

      navigate("/project-templates");
    } catch (err) {
      if (err.response?.status === 422) {
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };


  const [selectOptions, setSelectOptions] = useState({
    Categories: [],
    SubCategories: [],
  })

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));

    if (name == "organization_project_category_id") {
      setFormData((prev) => ({ ...prev, organization_project_subcategory_id: "" }));
      setSelectOptions((prev) => ({ ...prev, SubCategories: [] }));
    }
  };



  const fetchProjectCategories = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-categories`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      console.log("response Categories is : ", response);

      setSelectOptions((prev) => ({ ...prev, Categories: response.data.data }));
    } catch (e) {
      console.error("Failed to load Categories");
    }
  };

  const fetchProjectSubCategories = async (category_id) => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-sub-categories`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
          category_id
        },
      });

      console.log("response SubCategories is : ", response);

      setSelectOptions((prev) => ({ ...prev, SubCategories: response.data.data }));
    } catch (e) {
      console.error("Failed to load SubCategories");
    }
  };

  useEffect(() => {
    fetchProjectCategories();
  }, [org?.organization_id]);

  useEffect(() => {
    if (formData?.organization_project_category_id) {
      fetchProjectSubCategories(formData?.organization_project_category_id);

    }

  }, [formData?.organization_project_category_id]);


  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={"Project Templates"}
        addMessage={"Project Templates"}
        homeLink={"/project-templates"}
        homeText={"Project Templates"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>

             
<Autocomplete
  fullWidth
  options={selectOptions?.Categories || []}
  getOptionLabel={(option) => option.project_category_name || ""}
  value={
    selectOptions?.Categories?.find(
      (cat) =>
        cat.organization_project_category_id ===
        formData.organization_project_category_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_category_id:
        newValue?.organization_project_category_id || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project Category *"
      error={!!formErrors.organization_project_category_id}
      helperText={formErrors.organization_project_category_id}
    />
  )}
/>



<Autocomplete
  fullWidth
  disabled={selectOptions?.SubCategories?.length === 0}
  options={selectOptions?.SubCategories || []}
  getOptionLabel={(option) => option.project_subcategory_name || ""}
  value={
    selectOptions?.SubCategories?.find(
      (cat) =>
        cat.organization_project_subcategory_id ===
        formData.organization_project_subcategory_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_task_subcategory_id:
        newValue?.organization_project_subcategory_id || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project Sub Category"
      error={!!formErrors.organization_project_task_subcategory_id}
      helperText={
        selectOptions?.SubCategories?.length === 0
          ? "No SubCategories Available For This Category"
          : formErrors.organization_project_task_subcategory_id
      }
    />
  )}
/>


                <TextField
                  fullWidth
                  name="template_name"
                  label="Project template Name *"
                  value={formData.template_name}
                  onChange={handleChange}
                  error={!!formErrors.template_name}
                  helperText={formErrors.template_name}
                />


                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  label="Project Template Description "
                  name="template_description"
                  value={formData.template_description}
                  onChange={handleChange}
                  error={!!formErrors.template_description}
                  helperText={formErrors.template_description}
                />

              </Grid>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleSubmit}
                disabled={loading || btnLoading}
                sx={{
                  borderRadius: 2,
                  minWidth: 120,
                  textTransform: "capitalize",
                  fontWeight: 500,
                  mt: 2
                }}
              >
                {loading || btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : mode === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default ProjectTemplateForm